<template>
  <AccountIcon :image-url="imageUrl" :size="80" />
</template>
<script>
import AccountIcon from './AccountIcon'
export default {
  components: { AccountIcon },
  props: {
    imageUrl: {
      type: String,
      required: true
    }
  }
}
</script>
